import React from 'react';
import { useParams } from 'react-router-dom';
import PerformData from './PerformData';
import BreadCrumb from './BreadCrumb';

function PerformDataPage() {
    const { id, plantName } = useParams(); // Get dynamic route param

    return (
        <div className="container-fluid">
            <BreadCrumb />
            <PerformData id={id} plantName={plantName} /> {/* Pass ID to child */}
        </div>
    );
}

export default PerformDataPage;
